import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { WorkflowApiService } from '@selfai-platform/pipeline-api';
import { WorkflowInfo } from '@selfai-platform/pipeline-common';
import { KE_WORKFLOWS_LIST_ENTITY_NAME } from '@selfai-platform/store';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SchedulesWorkflowsListDataService extends DefaultDataService<WorkflowInfo> {
  constructor(
    public override http: HttpClient,
    public override httpUrlGenerator: HttpUrlGenerator,
    private readonly workflowApiService: WorkflowApiService,
  ) {
    super(KE_WORKFLOWS_LIST_ENTITY_NAME, http, httpUrlGenerator);
  }

  override getAll(): Observable<WorkflowInfo[]> {
    return this.workflowApiService
      .getAllWorkflows()
      .pipe(map((items) => items.map((item) => ({ ...item, name: item.name }))));
  }
}
